import { useState, useMemo, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchHeldeskLocationInfo, ILocation } from '../../../../libraries/location';
import LocationsForm from '../../../components/location-edit/locations-form';
import Header from '../../../components/util/header';
import { Language } from '../../../languages/languageHandler';
import { AppState } from '../../../client-redux/reducers';
import { useStatusOperDialog, isZarphSuccessResponse } from '../../../context/status-oper-dialog';
import './styles.scss';

enum MODE {
  READ = 'read',
  EDIT = 'edit',
  NEW = 'new'
}

const HelpdeskLocation = () => {
  const lang = useSelector<AppState, Language>(state => state.lang.lang);
  const currencyList = useSelector((state: AppState) => state.currencies.currencies);
  const controller = useRef(new AbortController()).current;

  const { mode: modeParam, entid, sid } = useParams();

  const [loading, setLoading] = useState(false);
  const [location, setLocation] = useState<ILocation | null>(null);

  const { handleApiError } = useStatusOperDialog();

  const mode = useMemo(() => {
    if (modeParam === MODE.NEW || modeParam === MODE.EDIT || modeParam === MODE.READ) {
      return modeParam as MODE;
    }
    return MODE.READ;
  }, [modeParam]);

  useEffect(() => {
    getLocationInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entid, sid]);

  const getLocationInfo = () => {
    if (mode === MODE.NEW || !entid || !sid) return;

    setLoading(true);

    fetchHeldeskLocationInfo(true, Number(entid), Number(sid))
      .then(response => {
        if (isZarphSuccessResponse(response, [9004])) {
          setLocation(response.data.shops?.[0] || null);
        } else {
          handleApiError(response, lang.ALERT_ERROR_FETCHING_DATA);
        }
      })
      .catch(err => {
        handleApiError(err, lang.ALERT_ERROR_FETCHING_DATA);
      })
      .finally(() => {
        setLoading(false);
      });

    return () => controller.abort();
  };

  return (
    <div className="local">
      <Header
        pageTitle={mode !== MODE.NEW ? `${lang.GLOBAL_LOCATION} ${entid}/${sid}` : `${lang.LOCATIONS_OPEN_NEW}`}
      />

      <LocationsForm
        lang={lang}
        location={location}
        currencyList={currencyList}
        loading={loading}
        mode={mode}
        workflow="helpdesk"
        reloadLocations={getLocationInfo}
      />
    </div>
  );
};

export default HelpdeskLocation;
